<div class="container px-4 sm:px-6 md:px-8 py-4 sm:py-6 max-w-4xl mx-auto">
  <div class="card-container bg-white rounded-lg p-4 sm:p-6 md:p-8 lg:p-10 shadow-lg">
    <h3 class="text-center text-xl sm:text-2xl md:text-3xl font-bold mb-6 sm:mb-8">Harap baca dengan seksama Syarat dan Ketentuan Aplikasi/Portal PRUWorks terlampir</h3>
    <p class="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4 text-justify">Syarat dan Ketentuan Umum layanan aplikasi/portal PRUWorks dari PT Prudential Life Assurance Indonesia (berikut
      semua lampiran, dan/atau perubahannya dan/atau pembaharuannya selanjutnya disebut sebagai "Ketentuan"). Ketentuan
      ini merupakan perjanjian yang mengatur mengenai syarat, ketentuan, serta hak dan kewajiban yang mengikat antara PT
      Prudential Life Assurance Indonesia ("Prudential Indonesia" atau "Kami") dengan Pemegang
      Polis/Tertanggung/Mitra/RS atau Klinik Rekanan sebagai pengguna jasa layanan Kami. </p>
    <p class="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4 text-justify">Kami adalah perusahaan asuransi yang telah terdaftar dan diawasi oleh Otoritas Jasa Keuangan (OJK) berkedudukan
      di Jakarta.</p>


    <ol class="item-list" type="A">
      <li><strong>PENDAHULUAN</strong>
        <div>Aplikasi PRUWorks adalah platform yang dibuat oleh Kami dimana Anda dapat mengakses fitur, layanan, dan
          informasi tertentu yang disediakan oleh Kami. Aplikasi PRUWorks akan diperbarui dari waktu ke waktu untuk
          menambah, menghapus, dan mengubah layanan, informasi, dan fitur yang tersedia. </div>
      </li>
      <li><strong>PENDAFTARAN</strong>
        <div>Anda berhak memperoleh dan menggunakan portal/aplikasi PRUWorks jika Anda tunduk pada Ketentuan ini.</div>
      </li>
      <li><strong>KETENTUAN PENGGUNAAN</strong>
        <div>
          <ol>
            <li>Untuk mendapatkan layanan ini Anda perlu untuk melakukan registrasi di portal/aplikasi PRUWorks dengan
              menyampaikan informasi yang benar, tepat dan terkini mengenai diri Anda.</li>
            <li>Anda perlu memahami bahwa detail informasi kata kunci (password) rahasia dan/atau kode verifikasi berupa
              Kode Sandi Sekali Pakai (One Time Password/OTP) yang dikirimkan melalui SMS ke alamat email atau nomor
              telepon terdaftar saat melakukan registrasi adalah rahasia dan karenanya Anda tidak akan mengungkapkan
              detail informasi tersebut kepada pihak ketiga manapun. Kode verifikasi hanya akan secara resmi diminta
              melalui dan hanya boleh Anda kirim ke aplikasi PRUWorks Anda, Kami atau petugas Kami tidak akan menanyakan
              kode verifikasi melalui cara lain. Anda setuju untuk menanggung setiap risiko terkait pengungkapan
              informasi registrasi Anda kepada pihak ketiga manapun dan bertanggung jawab penuh atas setiap konsekuensi
              yang berkaitan dengan itu. Setiap penyampaian OTP yang diverifikasi dari akun Anda setelah registrasi akan
              dianggap sebagai registrasi resmi.</li>
            <li>Anda perlu memahami bahwa detail informasi log-in Anda adalah rahasia dan karenanya Anda tidak akan
              mengungkapkan detail informasi log-in Anda kepada pihak ketiga manapun. User Name atau Password hanya akan
              secara resmi diminta melalui dan hanya boleh Anda kirim ke aplikasi PRUWorks Anda, Kami atau petugas Kami
              tidak akan menanyakan password melalui cara lain. Anda setuju untuk menanggung setiap risiko terkait
              pengungkapan informasi <i>log-in</i> Anda kepada pihak ketiga manapun dan bertanggung jawab penuh atas
              setiap
              konsekuensi yang berkaitan dengan itu.</li>
            <li>Anda dapat menggunakan portal/aplikasi PRUWorks untuk mendapatkan informasi dan/atau melakukan transaksi
              sehubungan dengan layanan Polis yang telah disediakan oleh Kami.</li>
            <li>Melalui aplikasi PRUWorks, Anda dapat:
              <div>
                <ol type="i">
                  <li>Mengakses informasi data Polis</li>
                  <li>Mengakses informasi Tertanggung beserta manfaatnya</li>
                  <li>Mengakses informasi klaim dan ekses klaim Tertanggung </li>
                  <li>Mengajukan klaim secara elektronik</li>
                  <li>Mengakses informasi Rumah Sakit terdekat atau berdasarkan rekomendasi Kami</li>
                  <li>Mengakses e-card dan buku panduan</li>
                  <li>Mengakses informasi umum lainnya yang tersedia di aplikasi PRUWorks</li>
                </ol>
              </div>
            </li>
            <li>Dengan melakukan transaksi melalui aplikasi PRUWorks, Anda mengakui semua komunikasi dan instruksi dari
              Anda yang diterima Kami akan diperlakukan sebagai alat bukti yang sah meskipun dokumen tidak dibuat secara
              tertulis dan/atau dokumen tidak ditandatangani oleh Anda dan Kami.</li>
            <li>Kami mengumpulkan dan memproses informasi pribadi Anda, alamat surat elektronik (surel/e-mail), dan
              nomor telepon seluler. </li>
            <li>Portal/Aplikasi PRUWorks memungkinkan Anda untuk untuk dapat mengetahui lokasi Rumah Sakit terdekat.
              Karena itu, fiturGPS (Global Positioning System) sudah harus aktif pada computer atau telepon selular
              (handphone) yang Anda gunakan untuk mengakses portal/aplikasi PRUWorks.Dengan demikian, portal/aplikasi
              PRUWorks akan mampu mendeteksi lokasi GPS Anda dan mengirimkan informasi lokasi Rumah Sakit terdekat
              dengan posisi Anda. Perlu anda ketahui, bahwa dengan mengaktifkan fitur ini berarti anda telah menyatakan
              persetujuan anda kepada kami untuk mendapatkan dan menyimpan rekam jejak lokasi Pribadi anda dari waktu ke
              waktu saat anda menggunakan aplikasi PRUWorks.</li>
            <li>Anda setuju untuk tidak menyalahgunakan aplikasi ini untuk tujuan penipuan, menimbulkan ketidaknyamanan
              bagi orang lain, maupun segala perbuatan yang melanggar hukum.</li>
            <li>Anda tidak diperkenankan untuk membahayakan, mengubah atau memodifikasi portal/aplikasi PRUWorks atau
              mencoba untuk membahayakan, mengubah atau memodifikasi portal/aplikasi PRUWorks dengan cara apapun. </li>
            <li>Anda wajib melakukan peningkatan versi (upgrade) aplikasi PRUWorks di telepon seluler (handphone) atas
              permintaan Kami. Kelalaian Anda dalam melakukan peningkatan versi (upgrade) aplikasi PRUWorks menyebabkan
              Anda tidak dapat menggunakan aplikasi PRUWorks atau hanya dapat mengakses fitur tertentu di aplikasi
              PRUWorks. </li>
            <li>Biaya yang timbul untuk mengakses portal/aplikasi PRUWorks ini atau biaya jasa layanan internet yang
              merupakan bagian dari paket layanan operator telekomunikasi adalah menjadi kewajiban Anda dan diluar
              tanggung jawab Kami.</li>
            <li>Anda harus menghubungi perusahaan yang menyediakan layanan operator telepon seluler (Operator Seluler)
              yang Anda gunakan untuk mengatasi masalah yang berkaitan dengan KartuSIM (Subscriber Identity Modul),
              jaringan Operator Seluler, maupun jaringan layanan internet pada telepon seluler (handphone).</li>
            <li>Dengan pemberitahuan sebelumnya dari Kami, sesuai dengan ketentuan dan peraturan perundang-undangan yang
              berlaku, Kami berhak untuk:
              <div>
                <ol type="i">
                  <li>membatasi, mengurangi, mengubah, membatalkan, dan/atau menghentikan seluruh atau sebagian layanan
                    yang tersedia pada portal/aplikasi PRUWorks;dan </li>
                  <li>menambah, mengurangi, menarik kembali atau mengubah jenis transaksi yang sudah ada atau yang dapat
                    dilakukan melalui portal/aplikasi PRUWorks.</li>
                </ol>
              </div>
            </li>
            <li>Kami dapat mengubah KetentuanPRUWorks ini setiap saat dalam bentuk dan melalui sarana apa pun sesuai
              dengan ketentuan hukum yang berlaku. Anda berkewajiban untuk tunduk pada Ketentuan terbaru dari Kami untuk
              bisa terus menggunakan portal/aplikasi PRUWorks ini. </li>
            <li>Anda dengan ini menyatakan kesediaan untuk tunduk pada Ketentuan PRUWorksserta seluruh Ketentuan yang
              berlaku di PT Prudential Life Assurance Indonesia yang mengatur mengenai jasa, fasilitas, dan transaksi
              yang dapat Anda lakukan. Ketentuan ini akan diberitahukan oleh Kami kepada Anda dalam bentuk dan melalui
              sarana apa pun sesuai dengan ketentuan hukum yang berlaku.</li>
          </ol>
        </div>
      </li>
      <li><strong>KODE KEAMANAN</strong>
        <div>
          <ol>
            <li>Kode Keamanan dalam portal/aplikasi PRUWorks adalah username (Nama Pengguna), password (Kata Sandi), dan
              kode verifikasi yang diberikan oleh Kami yang memungkinkan Anda mengakses dan bertransaksi melalui
              Aplikasi PRUWorks. </li>
            <li>Anda wajib menjaga kerahasiaan Kode Keamanan. Kami tidak bertanggung jawab atas penyalahgunaan apabila
              Anda memberitahukan Kode Keamanan tersebut kepada pihak lain baik secara sengaja maupun tidak sengaja.Kami
              tidak akan memberikan ganti rugi dan/atau pertanggungjawaban dalam bentuk apapun kepada Anda atau pihak
              manapun atas segala tanggung jawab, gugatan dan tuntutan sehubungan dengan diketahuinya Kode Keamanan
              tersebut oleh pihak lain.</li>
            <li>Apabila Anda mencurigai adanya pihak lain yang mungkin bisa mendapatkan kendali apapun atas Kode
              Keamanan milik Anda, maka Anda harus memberitahu Kami sesegera mungkin sehingga Kami dapat melakukan
              tindakan dan langkah-langkah yang diperlukan.</li>
            <li>Penggunaan <i>Password</i> (Kata Sandi) maupun kode verifikasi yang Kami kirimkan melalui
              portal/aplikasi
              PRUWorks mempunyai kekuatan hukum yang sama dengan perintah tertulis yang ditandatangani oleh Anda.</li>
            <li>Anda bertanggungjawab memastikan bahwa perangkat computer atau seluler (handphone) yang Anda gunakan
              pada saat bertransaksi menggunakan portal/aplikasi PRUWorks bebas dari virus, malware dan/hal lainnya yang
              dapat merugikan Anda. </li>
            <li>Kami menganjurkan Anda untuk melakukan penggantian <i>Password</i> (Kata Sandi) secara berkala.</li>
          </ol>
        </div>
      </li>
      <li><strong>KEADAAN KAHAR (FORCE MAJEURE)</strong>
        <div>Dalam hal Kami tidak dapat melaksanakan instruksi dari Anda, baik sebagian maupun seluruhnya karena
          kejadian-kejadian atau hal-hal di luar kekuasaan atau kemampuan Kami, termasuk namun tidak terbatas pada
          bencana alam, perang, huru-hara, peralatan/sistem/transmisi dalam keadaan tidak berfungsi, terjadinya gangguan
          listrik, gangguan telekomunikasi, adanya kebijakan pemerintah yang melarang Kami memberikan layanan pada
          portal/aplikasi PRUWorks, serta kejadian-kejadian atau hal-hal lain di luar kekuasaan atau kemampuan Kami,
          maka Anda dengan ini membebaskan Kami dari segala macam tuntutan apa pun dan dalam bentuk apa pun terkait
          dengan hal tersebut.</div>
      </li>
      <li><strong>PILIHAN HUKUM DAN DOMISILI</strong>
        <div>
          Ketentuan pada portal/aplikasi PRUWorks ini, berikut dengan seluruh perubahan/penambahannya maupun
          pembaharuannya, ditafsirkan dan dilaksanakan berdasarkan hukum yang berlaku di Negara Republik Indonesia.
          Setiap sengketa yang timbul menurut atau berdasarkan Ketentuan pada portal/aplikasi PRUWorks akan diselesaikan
          dengan cara sebagai berikut:

          <ol type="i">
            <li>Anda dan Kami setuju bahwa setiap perselisihan atau perbedaan pendapat yang timbul dari dan/atau
              berkenaan dengan pelaksanaan Ketentuan portal/aplikasi PRUWorks, sepanjang memungkinkan, diselesaikan
              dengan cara musyawarah.</li>
            <li>Setiap perselisihan atau perbedaan pendapat yang tidak dapat diselesaikan secara musyawarah oleh Anda
              dan Kami, harus diselesaikan melalui mediasi di bidang Asuransi. </li>
            <li>Setiap perselisihan atau perbedaan pendapat antara Anda dan Kami yang tidak dapat diselesaikan melalui
              musyawarah dan/atau mediasi di bidang Asuransi, akan diselesaikan melalui salah satu Pengadilan Negeri di
              wilayah Republik Indonesia. </li>
          </ol>
        </div>
      </li>
      <li><strong>ALAT DAN PEMANTAUAN</strong>
        <div>
          <ol>
            <li>Kami dapat menggunakan alat analisis data untuk memantau penggunaan portal/aplikasi PRUWorks dan layanan
              portal/aplikasi PRUWorks yang Anda gunakan untuk memberikan Kami informasi yang akan digunakan dalam
              memutuskan apakah Kami akan melakukan perubahan pada portal/aplikasi PRUWorks dan layanan portal/aplikasi
              PRUWorks serta untuk melakukan pembuatan profil pemasaran, maupun profil lain. </li>
            <li>Kami juga dapat mengumpulkan dan menggunakan data teknis serta informasi terkait, termasuk tetapi tidak
              terbatas, pada informasi teknis tentang perangkat Anda. Hal ini termasuk data mengenai system, perangkat
              lunak aplikasi serta periferalnya untuk memfasilitasi penyediaan pembaruan, dukungan produk, dan layanan
              lain kepada Anda yang terkait dengan portal/aplikasi PRUWorks.</li>
          </ol>
        </div>
      </li>
      <li><strong>PENGAKHIRAN PENGGUNAAN PRUWorks</strong>
        <div>
          <ol>
            <li>Fasilitas pada aplikasiPRUWorks pada telepon seluler (handphone) akan berakhir jika Anda menghapus akun
              Anda pada aplikasi PRUWorks.</li>
            <li>Kami berhak mengakhiri pemberian fasilitas PRUWorks kepada Andaapabila Anda menggunakan aplikasiPRUWorks
              untuk melakukan suatu tindakan yang melanggar hukum. </li>
            <li>Kami berhak secara sepihak menghentikan sementara atau menangguhkan layanan portal/aplikasi PRUWorks
              tanpa pemberitahuan terlebih dahulu kepada Anda apabila terjadi hal-hal sebagai berikut:
              <div>
                <ol type="i">
                  <li>Jika terjadi gangguan teknis pada jaringan;</li>
                  <li>Jaringan (network) secara teknis sedang dalam peningkatan, perubahan dan/atau pemeliharaan;</li>
                  <li>Jaringan (network) terindikasi digunakan untuk kejahatan atau kegiatan yang bertujuan melanggar
                    hukum.</li>
                </ol>
              </div>
            </li>
          </ol>
        </div>
      </li>
      <li><strong>PERSETUJUAN</strong>
        <div>
          <ol>
            <li>Anda menyatakan dan menjamin bahwa Anda adalah individu yang sah secara hukum untuk terikat dalam
              perjanjian berdasarkan hukum Republik Indonesia, secara khusus terikat dalam Ketentuan Penggunaan
              portal/aplikasi PRUWorks ini.</li>
            <li>Dengan menggunakan aplikasi PRUWorks dan memberikan data-data Pribadi anda melalui aplikasi ini, anda
              telah menyatakan persetujuan anda kepada kami untuk mengumpulkan, menggunakan, mengelola dan mengungkapkan
              informasi Pribadi anda sesuai dengan ketentuan penggunaan layanan PRUWorks ini, ataupun untuk tujuan
              pemasaran maupun untuk tujuan pengungkapan lainnya yang diwajibkan oleh peraturan dan atau
              perundang-undangan yang berlaku.</li>
          </ol>
        </div>
      </li>
      <li><strong>PENGGUNAAN</strong>
        <div>
          Layanan PRUWorks ini hanya dapat digunakan oleh Karyawan dari Pemegang Polis yang Diasuransikan atas
          suatu polis asuransi yang diterbitkan oleh Prudential Indonesia yang nomor Polisnya terdaftar pada
          aplikasi PRUWorks.
        </div>
      </li>
      <li><strong>PEMBLOKIRAN AKUN</strong>
        <div>
          <ol type="1.2">
            <li>Atas permintaan Anda, Kami akan memblokir akun PRUWorks. Selain itu, jika menurut pertimbangan Kami,
              terjadi hal-hal yang merugikan dan/atau dapat merugikan Kami atau Anda atau pihak ketiga lainnya, Kami
              juga akan melakukan pemblokiran tersebut. </li>
            <li>Pemblokiran akun dapat terjadi termasuk karena, namun tidak terbatas pada, kejadian-kejadian berikut
              ini:
              <div>
                <ol type="i">
                  <li>Laporan Anda bahwa telepon selular Anda hilang atau dicuri atau diretas;</li>
                  <li>Perintah pemblokiran yang diterbitkan oleh institusi pemerintah atau moneter atau berdasarkan
                    perintah pengadilan;</li>
                  <li>Penggunaan akun PRUWorks dengan cara yang bertentangan dengan Ketentuan Penggunaan portal/aplikasi
                    PRUWorks, syarat dan ketentuan lain yang berlaku untuk fitur atau layanan lain di portal/aplikasi
                    PRUWorks, kebijakan privasi PRUWorks dan setiap hukum dan peraturan perundang-undangan yang berlaku;
                  </li>
                  <li>Alasan lain yang merugikan Anda atau Kami, termasuk tindakan abusive dan fraud atau ketika sistem
                    Kami menangkap pola transaksi keuangan yang mencurigakan</li>
                </ol>
              </div>
            </li>
          </ol>
        </div>
      </li>
      <li><strong>PENUTUPAN AKUN</strong>
        <ol type="1.4">
          <li>Akun PRUWorks Anda dapat ditutup karena hal-hal sebagai berikut:
            <div>
              <ol type="a">
                <li>Permintaan oleh Anda;</li>
                <li>Kebijakan Kami berdasarkan hukum dan peraturan perundang-undangan yang berlaku;</li>
                <li>Keadaan kahar terjadi selama 3 (tiga) bulan atau lebih secara berturut-turut; dan/atau</li>
                <li>Alasan lain sehubungan dengan pemblokiran akun.</li>
              </ol>
            </div>
          </li>
        </ol>
      </li>
      <li><strong>TANGGUNG JAWAB DAN KEWAJIBAN ANDA</strong>
        Sebagai tambahan dari tanggung jawab Anda yang diatur dalam bagian lain dari Ketentuan Penggunaan PRUWorks ini,
        Anda bertanggung jawab atas:
        <div>
          <ol type="8.1">
            <li>Keamanan dan kepemilikan telepon seluler Anda yang digunakan untuk mengakses akun PRUWorks termasuk
              dengan secara wajar menjaga dan menyediakan memori penyimpanan yang cukup untuk mencegah setiap kegagalan
              atau gangguan atas setiap proses layanan PRUWorks yang disebabkan oleh kegagalan fungsi telepon seluler
              Anda;</li>
            <li>Kemanan dan validitas nomor telepon seluler Anda yang Anda daftarkan untuk mengakses akun PRUWorks,
              karenanya Kami tidak bertanggung jawab atas setiap klaim yang timbul jika nomor telepon seluler yang Anda
              daftarkan dikuasai oleh pihak lain, menjadi tidak aktif berdasarkan kebijakan perusahaan telekomunikasi
              dan/atau menjadi dormant;</li>
            <li>Kerahasiaan OTP yang dikirim kepada Anda dan/atau Password yang ditetapkan oleh Anda; </li>
          </ol>
        </div>
      </li>
      <li><strong>TANGGUNG JAWAB KAMI</strong>
        <div>
          <ol type="1.5">
            <li>Kami tidak bertanggung jawab atas kerugian tidak langsung dan immateril, termasuk biaya, bunga,
              kerusakan atau kerugian dalam bentuk atau jenis apapun (termasuk cidera pribadi, tekanan emosional dan
              hilangnya data, barang, pendapatan, laba, penggunaan atau keuntungan ekonomis lainnya) yang Anda atau
              pihak ketiga alami.</li>
            <li>Kami tidak bertanggung jawab atas setiap kerugian, termasuk biaya, bunga, kerusakan atau kerugian dalam
              bentuk atau jenis apapun (termasuk cidera pribadi, tekanan emosional dan hilangnya data, barang,
              pendapatan, laba, penggunaan atau keuntungan ekonomis lainnya) yang Anda atau pihak ketiga alami karena
              kesalahan Anda atau pihak ketiga selain Kami.</li>
          </ol>
        </div>
      </li>
      <li><strong>KEADAAN KAHAR</strong>
        <div>Layanan Kami dapat diinterupsi oleh kejadian atau hal tertentu di luar kewenangan dan kontrol Kami (Keadaan
          Kahar), termasuk namun tidak terbatas pada bencana alam, gangguan listrik, gangguan telekomunikasi, kebijakan
          pemerintah, dan hal-hal lainnya yang di luar kewenangan dan kontrol Kami. Anda oleh karenanya setuju untuk
          melepaskan Kami dari setiap klaim, jika Kami tidak dapat memenuhi instruksi Anda melalui akun PRUWorks baik
          sebagian maupun seluruhnya karena Keadaan Kahar.</div>
      </li>
      <li><strong>HUKUM YANG MENGATUR</strong>
        <div>Ketentuan Penggunaan PRUWorks ini diatur berdasarkan hukum Republik Indonesia. Setiap dan seluruh
          perselisihan yang timbul dari penggunaan layanan Kami akan tunduk pada yurisdiksi eksklusif di Pengadilan
          Negeri Jakarta Selatan.</div>
      </li>
      <li><strong>PERUBAHAN</strong>
        <div>
          <p class="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4 text-justify">Ketentuan Penggunaan PRUWorks ini, sebagian atau seluruhnya, termasuk setiap fitur atau layanan yang
            ditawarkan dalam akun PRUWorks, dapat dimodifikasi, ditambahkan, atau diubah dari waktu ke waktu berdasarkan
            kebijakan Kami sendiri dengan atau tanpa pemberitahuan kepada Anda. Penggunaan Anda secara berkelanjutan
            atas PRUWorks setelah modifikasi, variasi dan/atau perubahan atas Ketentuan Penggunaan PRUWorks merupakan
            persetujuan dan penerimaan Anda atas modifikasi, variasi dan/atau perubahan tersebut. Jika Anda ingin
            menolak modifikasi, variasi dan/atau perubahan tersebut, maka Anda harus berhenti mengakses atau menggunakan
            PRUWorks dan/atau layanan kami.</p>
          <p class="text-sm sm:text-base leading-relaxed mb-3 sm:mb-4 text-justify">Penggunaan Anda atas akun PRUWorks menandakan persetujuan Anda untuk tunduk pada (i) Ketentuan ini; (ii)
            syarat dan ketentuan umum penggunaan portal/aplikasi PRUWorks; (iii) syarat dan ketentuan khusus yang
            berlaku untuk masing-masing fitur layanan yang tersedia dalam portal/aplikasi PRUWorks; (iv) kebijakan
            privasi; dan (v) setiap hukum dan peraturan perundang-undangan yang berlaku.</p>
        </div>
      </li>
    </ol>
  </div>

</div>